/**
 * Canonical gate for the Structure Reorganization module.
 *
 * Resolves Entitlement → Workspace module → Module policy → Personal flag via
 * the one policy-aware gate (build contract §2.7). The server enforces the same
 * opt-in in internal_structure_reorg_actor (migration 732), so this gate is a
 * courtesy, not the wall.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function useStructureReorgEnabled(): boolean {
  return useModuleGate('structure_reorg');
}
